// addressSlice.js
import { apiSlice } from "./apiSlice";
import {
  GET_ADDRESSES_URL,
  ADD_ADDRESS_URL,
  UPDATE_ADDRESS_URL,
  DELETE_ADDRESS_URL,
} from "../constants";

export const addressSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAddresses: builder.query({
      query: () => ({
        url: GET_ADDRESSES_URL,
        method: "GET",
      }),
      providesTags: ["Address"],
    }),
    addAddress: builder.mutation({
      query: (data) => ({
        url: ADD_ADDRESS_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Address"],
    }),
    updateAddress: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `${UPDATE_ADDRESS_URL}/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Address"],
    }),
    deleteAddress: builder.mutation({
      query: (id) => ({
        url: `${DELETE_ADDRESS_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Address"],
    }),
  }),
});

export const {
  useGetAddressesQuery,
  useAddAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
} = addressSlice;
